import * as Yup from "yup"

const CreateBrandValidation = {
	name: Yup.string().required(),
	company: Yup.string().when('createNewCompany', {
		is: false,
		then: (schema) => schema.required(),
		otherwise: (schema) => schema.notRequired(),
	}),
	createNewCompany: Yup.boolean(),
	companyData: Yup.object().when('createNewCompany', {
		is: true,
		then: (schema) => schema.shape({
			name: Yup.string().required('Nome società obbligatorio').max(256, 'Nome troppo lungo'),
			address: Yup.string().required('Indirizzo obbligatorio').max(256, 'Indirizzo troppo lungo'),
			city: Yup.string().required('Città obbligatoria').max(100, 'Città troppo lunga'),
			province: Yup.string().required('Provincia obbligatoria').max(50, 'Provincia troppo lunga'),
			postalCode: Yup.string().required('CAP obbligatorio').max(20, 'CAP troppo lungo'),
			country: Yup.string().required('Paese obbligatorio').max(100, 'Paese troppo lungo'),
			phone: Yup.string().required('Telefono obbligatorio').max(30, 'Telefono troppo lungo'),
			vatCode: Yup.string()
				.required('Partita IVA obbligatoria')
				.matches(/^\d{11}$/, 'Partita IVA deve essere di 11 cifre')
				.max(20, 'Partita IVA troppo lunga'),
		}).required(),
		otherwise: (schema) => schema.notRequired(),
	}),
}

export default Yup.object()
	.shape(
		CreateBrandValidation,
	)
	.required()
